<template>
  <div class="app-container">
    <div class="table-box">
      <el-form
        :model="queryParams"
        ref="queryForm"
        size="small"
        :inline="true"
        v-show="showSearch"
        label-width="100px"
      >
        <el-form-item label="淤地坝名称" prop="ydbName">
          <el-input
            v-model="queryParams.ydbName"
            placeholder="请输入淤地坝名称"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="行政区划" prop="address">
          <el-input
            v-model="queryParams.address"
            placeholder="请输入行政区划"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="有无问题" prop="haveIssue">
          <el-select
            v-model="queryParams.haveIssue"
            placeholder="请选择有无问题"
            clearable
          >
            <el-option
              v-for="dict in have_issue"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态" prop="examineStatus">
          <el-select
            v-model="queryParams.examineStatus"
            placeholder="请选择审核状态"
            clearable
          >
            <el-option
              v-for="dict in examine_status"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleQuery"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
            >重置</el-button
          >
          <el-button
            type="warning"
            plain
            icon="el-icon-download"
            size="mini"
            @click="xjlExport"
            >巡检率导出</el-button
          >
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="patrolRecordList" max-height="680">
        <el-table-column label="序号" align="center" prop="id" />
        <el-table-column label="淤地坝名称" align="center" prop="ydbName" />
        <el-table-column label="行政区划" align="center" prop="address" />
        <el-table-column label="巡检人" align="center" prop="patrolUser" />
        <el-table-column
          label="巡检时间"
          align="center"
          prop="patrolTime"
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.patrolTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="提交时间"
          align="center"
          prop="submitTime"
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.submitTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="有无问题" align="center" prop="haveIssue">
          <template slot-scope="scope">
            <el-button
              :type="scope.row.haveIssue == '1' ? 'danger' : 'primary'"
              plain
              >{{ scope.row.haveIssue == "1" ? "有问题" : "无问题" }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="审核状态" align="center" prop="examineStatus">
          <template slot-scope="scope">
            <span v-for="dict in examine_status" :key="dict.value">
              <el-button
                plain
                v-if="scope.row.examineStatus == dict.value"
                :type="dict.type"
                >{{ dict.label }}</el-button
              >
            </span>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" prop="remark" />
        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="handleCheck(scope.row)"
              >{{ scope.row.examineStatus == "1" ? "查看" : "审核" }}</el-button
            >
            <!-- <el-button
            size="small"
            type="primary"
            @click="handleCheck(scope.row)"
            >查看</el-button
          > -->
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
    <!-- 添加或修改巡检记录对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="60%" append-to-body>
      <issue-record
        v-if="open"
        :currentRecord="form.currentRecord"
        @refreshPage="getList"
      />
    </el-dialog>

    <!-- 巡检率导出对话框 -->
    <el-dialog title="巡检率导出" :visible.sync="openExport" width="30%">
      <el-form
        :model="exportForm"
        :rules="exportRules"
        ref="exportForm"
        label-width="100px"
        class="exportForm"
      >
        <el-form-item label="导出市县级" prop="deptId">
          <el-cascader
            :options="deptOptions"
            :props="{ checkStrictly: true, value: 'deptId', label: 'deptName' }"
            v-model="exportForm.deptId"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="导出类型" prop="type">
          <el-select v-model="exportForm.type" placeholder="请选择">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导出年份" prop="year">
          <el-input type="number" v-model="exportForm.year"></el-input>
        </el-form-item>
        <el-form-item label="导出月份" prop="screen">
          <el-input type="number" v-model="exportForm.screen"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="openExport = false">取 消</el-button>
        <el-button type="primary" @click="determine('exportForm')"
          >导 出</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import IssueRecord from "./IssueRecord.vue";
import pagination from "@/components/Pagination/index.vue";

export default {
  name: "PatrolRecord",
  components: { IssueRecord, pagination },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 巡检记录表格数据
      patrolRecordList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        address: null,
        ydbName: null,
        haveIssue: null,
        examineStatus: 2,
        deptId: undefined,
        ydbdms: [],
        searchType: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {},
      openExport: false,
      exportForm: {},
      exportRules: {
        deptId: [
          { required: true, message: "请选择导出的市县", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择导出的类型", trigger: "change" },
        ],
        year: [
          { required: true, message: "请选择导出的年份", trigger: "change" },
        ],
        screen: [
          { required: true, message: "请选择导出的月份", trigger: "change" },
        ],
      },
      deptOptions: [],
      typeOptions: [
        {
          value: "period",
          label: "期",
        },
        {
          value: "month",
          label: "月",
        },
      ],
      have_issue: [
        {
          value: 1,
          label: "有问题",
        },
        {
          value: 2,
          label: "无问题",
        },
      ],
      examine_status: [
        {
          value: 1,
          label: "已审核",
          type: "success",
        },
        {
          value: 2,
          label: "未审核",
          type: "danger",
        },
        {
          value: 0,
          label: "无需审核",
          type: "info",
        },
      ],
      headers: {
        "Access-Token": this.$store.state.token,
      },
    };
  },
  created() {
    this.getList();
    this.getDeptOptions();
  },
  methods: {
    setTreeData(arr) {
      let map = {};
      arr.forEach((i) => {
        delete i["children"];
        map[i.deptId] = i;
      });
      let treeData = [];
      arr.forEach((child) => {
        const mapItem = map[child.parentId]; //判断当前数据的pId是否存在map中
        if (mapItem) {
          //存在则表示当前数据不是最顶层的数据
          //注意： 这里的map中的数据是引用了arr的它的指向还是arr,当mapItem改变时arr也会改变，踩坑点
          (mapItem.children || (mapItem.children = [])).push(child); //这里判断mapItem中是否存在child
        } else {
          //不存在则是顶层数据
          treeData.push(child);
        }
      });
      return treeData;
    },
    getDeptOptions() {
      Axios.get("/hzyApi/hwDocking/getDeptList", {
        headers: this.headers,
      }).then((res) => {
        // console.log("res ====", res);
        if (res.data.code == 200) {
          this.deptOptions = this.setTreeData(res.data.data);
        }
      });
    },
    xjlExport() {
      this.exportForm = {};
      this.openExport = true;
    },
    /**
     * 导出
     */
    determine(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var exportForm = JSON.parse(JSON.stringify(this.exportForm));
          exportForm.deptId = exportForm.deptId[exportForm.deptId.length - 1];
          console.log(exportForm);
          Axios.post(
            "http://111.21.216.203:10004/shanxiIpApi/hwDocking/export_inspection",
            exportForm,
            {
              responseType: "blob",
              params: exportForm,
            }
          ).then(async (res) => {
            let url = window.URL.createObjectURL(
              new Blob([res.data], { type: ".xlsx" })
            );
            let a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.setAttribute("download", `log_${new Date().getTime()}.xlsx`);
            document.body.appendChild(a);
            a.click();
            url = window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            this.openExport = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 查询巡检记录列表 */
    getList() {
      this.loading = true;
      this.patrolRecordList = [];
      this.queryParams.searchType = "1";
      this.queryParams.deptId = this.$store.state.regionCode;
      Axios.get("/hzyApi/hwDocking/getPatrolRecord", {
        params: this.queryParams,
        headers: this.headers,
      }).then((res) => {
        // console.log("===getPatrolRecord=========", res)
        if (res.data.code == 200) {
          this.patrolRecordList = res.data.rows;
          this.total = res.data.total;
        }
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        ydbName: null,
        haveIssue: null,
        examineStatus: null,
        remark: null,
        currentRecord: null,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 审核按钮操作 */
    handleCheck(row) {
      this.reset();
      this.open = true;
      this.title = "问题详情";
      this.form.currentRecord = row;
    },
  },
};
</script>

<style scoped>
.table-box {
  height: 90vh;
  overflow: hidden;
}
</style>
